/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpIcon20Regular = forwardRef('ArrowAUpIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M3.968 8.812a.75.75 0 1 1-1.06-1.061l5.236-5.237a2.625 2.625 0 0 1 3.712 0l5.237 5.237a.75.75 0 0 1-1.06 1.06l-5.238-5.236a1.142 1.142 0 0 0-.045-.043V17.5a.75.75 0 0 1-1.5 0V3.532l-.046.043-5.236 5.237Z" })));
});
